import { render, staticRenderFns } from "./SurveyOptionForm.vue?vue&type=template&id=26364068&scoped=true"
import script from "./SurveyOptionForm.vue?vue&type=script&lang=js"
export * from "./SurveyOptionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26364068",
  null
  
)

export default component.exports